import Image from "common/components/Image";
import confirmCalendar from "common/images/confirm-calendar.svg";
import { AppointmentStatus } from "common/types/scheduler";
import { toPhone } from "common/utils/formatting";
import { pluralized } from "common/utils/strings";

import Button from "client/common/components/buttons/Button";
import ErrorContainer from "client/common/components/errors/ErrorContainer";
import { useClinic } from "client/clinics/hooks";

import { useAppointmentBulkUpdateMutation } from "../hooks";
import { useDefaultCalendarId } from "../hooks/data";
import { ClientAppointmentWithForms } from "../types";

import styles from "../styles/AppointmentConfirm.module.less";

type AppointmentConfirmationProps = {
  appointmentIds: number[];
  onConfirm: (appointments: ClientAppointmentWithForms[]) => void;
};

const AppointmentConfirm = ({ appointmentIds, onConfirm }: AppointmentConfirmationProps) => {
  const calendar = useDefaultCalendarId();

  const {
    mutate: confirm,
    isPending: isConfirming,
    error,
  } = useAppointmentBulkUpdateMutation({
    onSuccess: (appointments) => onConfirm(appointments),
  });

  const clinic = useClinic();

  if (error) {
    return <ErrorContainer />;
  }

  return (
    <div className={styles.container}>
      <Image className={styles.image} src={confirmCalendar} alt="calendar" />
      <div className={styles.content}>
        <div className={styles.title}>
          Confirm your {pluralized(appointmentIds.length, "appointment")}
        </div>
        <div className={styles.body}>
          Need to cancel or reschedule? Call us at <strong>{toPhone(clinic.phone_number)}</strong>.
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          isLoading={isConfirming}
          onClick={() =>
            confirm({
              appointment_ids: appointmentIds,
              status: AppointmentStatus.Confirmed,
              calendar_id: calendar,
            })
          }
        >
          Confirm
        </Button>
      </div>
    </div>
  );
};

export default AppointmentConfirm;
